<template>
  <grid
    ref="grid"
    :config="gridConfig"
    class="no-grid-border"
    :addParamsToGetRequest="addParamsToGetRequest"
    :getRequestMiddleware="getRequestMiddleware"
    @onGet="handlerGetData"
  ></grid>
</template>

<script>
import gridConfig from './GridConfig'
import Tabs from '../Tabs.js'

export default {
  name: 'POReceivedToday',
  mixins: [Tabs],
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index')
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  }
}
</script>
